import StandardGateway from 'scripts/adapters/gateways/lib/standard_gateway';

export default class UserHttpGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/users/:userId');
  }

  updateActivationToken({ userId }) {
    const url = `${this.endpoint.set({ userId }).replaceUrl}/activation-token`;
    let resource = `${this.endpoint.patterns.replaceUrl}/activation-token`;

    return this.http.post(url, undefined, undefined, resource).catch(error => {
      throw error;
    });
  }
}
